export const SET_TWILIO_TOKEN = 'SET_TWILIO_TOKEN'



// WEBPACK FOOTER //
// ./src/store/modules/admin/app/types.js